import React, { useState } from "react";
import Select from "react-select";
import SpeedChart from "./Charts/SpeedChart";

export default function EMS() {
    const [selectedParameter, setSelectedParameter] = useState(null);

    const parameterOptions = [
        { value: "Load matrix", label: "Load matrix" },
        { value: "Engine speed", label: "Engine speed" },
        { value: "Speed", label: "Speed" },
        { value: "Atmospheric pressure", label: "Atmospheric pressure" },
        { value: "Outdoor temperature", label: "Outdoor temperature" },
        { value: "Coolant temperature", label: "Coolant temperature" },
        { value: "Charge air temperature", label: "Charge air temperature" },
        { value: "Oil pressure", label: "Oil pressure" },
        { value: "EMS", label: "EMS" },
        { value: "Fuel temperature", label: "Fuel temperature" },
        { value: "Reductant temperature", label: "Reductant temperature" },
    ];

    return (
        <div>
            <div className="container-fluid">
                {/* start page title */}
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0 font-size-18">EMS </h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#/">Dashboard</a></li>
                                    <li className="breadcrumb-item active">EMS</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* end row */}

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header p-1 pt-2">
                                <div className="row mb-3 d-flex justify-content-center">
                                    <div className="col-sm-12 col-md-12 col-lg-3 mb-1">
                                        <label>Select Parameter</label>
                                        <Select
                                            options={parameterOptions}
                                            value={selectedParameter}
                                            onChange={setSelectedParameter}
                                            isSearchable={true} // Enables search
                                            placeholder="Select Parameter"
                                            className="basic-single"
                                            classNamePrefix="select"
                                        />
                                    </div>

                                    <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                        <label>From</label>
                                        <input type="date" className="form-control" />
                                    </div>
                                    <div className="col-sm-12 col-md-12 col-lg-2 mb-1">
                                        <label>To</label>
                                        <input type="date" className="form-control" />
                                    </div>
                                    <div className="col-md-1 mt-4">
                                        <input type="submit" value="Search" className="mt-1 btn btn-primary waves-effect waves-light" />
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <SpeedChart />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
